/* eslint-disable @typescript-eslint/no-explicit-any, no-console */
import { isDebugMode } from './debug.js';
class ConsoleLogger {
    debug(...data) {
        if (isDebugMode()) {
            console.debug(...data);
        }
    }
    log(...data) {
        console.log(...data);
    }
    info(...data) {
        console.info(...data);
    }
    warn(...data) {
        console.warn(...data);
    }
    error(...data) {
        console.error(...data);
    }
}
class AnalyticsLogger {
    constructor(instance) {
        this.logger = instance;
    }
    set instance(instance) {
        this.logger = instance;
    }
    debug(...data) {
        this.logger.debug(...data);
    }
    log(...data) {
        this.logger.log(...data);
    }
    /**
     * analytics.init's `disabled` configuration causes reporters to log at `info` level instead of sending payload
     */
    info(...data) {
        this.logger.info(...data);
    }
    warn(...data) {
        this.logger.warn(...data);
    }
    error(...data) {
        this.logger.error(...data);
    }
}
const LOG = new AnalyticsLogger(new ConsoleLogger());
export default LOG;
//# sourceMappingURL=logger.js.map